import { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { setupDAL } from "./api";
import { NotFound } from "@roster-technologies/rosterui";

import "./App.scss";
import { Layout, Typography } from "antd";
import ApplicationFormWrapper from "./containers/ApplicationFormWrapper";

const { Content, Footer } = Layout;
const { Text, Link } = Typography;

setupDAL();

function App() {
    useEffect(() => {
        import("./phoneInputStyles");
    }, []);

    const urlSearchParams = new URLSearchParams(window.location.search);
    const hideParam = urlSearchParams.get("wl");

    return (
        <BrowserRouter>
            <Layout className="flex-container center">
                <Content style={{ maxWidth: 440 }} className="content">
                    <Routes>
                        <Route
                            path="/:formKey"
                            element={<ApplicationFormWrapper />}
                        />
                        <Route
                            path="/:formKey/embed"
                            element={<ApplicationFormWrapper isEmbedded />}
                        />
                        <Route path="/" element={<NotFound />} />
                    </Routes>
                </Content>
                <Footer
                    className="footer vertical flex-container center"
                    data-iframe-height
                    data-iframe-size>
                    {hideParam !== "1" && (
                        <>
                            <Text style={{ fontSize: 12 }}>Powered by</Text>
                            <Link
                                href="https://www.getroster.com"
                                target="_blank"
                                rel="noopener noreferrer nofollow">
                                <img
                                    height={24}
                                    src="/logo.svg"
                                    alt="roster-logo"
                                />
                            </Link>
                            <Text
                                style={{
                                    fontSize: 8,
                                    textAlign: "center",
                                    paddingTop: 8,
                                    color: "#595959",
                                }}>
                                Roster - Brand Ambassador Software for Ecommerce
                                Brands
                            </Text>
                        </>
                    )}
                </Footer>
            </Layout>
        </BrowserRouter>
    );
}

export default App;
